import { render, staticRenderFns } from "./ScanTraceableProduct.vue?vue&type=template&id=60c886d5&scoped=true&"
import script from "./ScanTraceableProduct.vue?vue&type=script&lang=js&"
export * from "./ScanTraceableProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c886d5",
  null
  
)

export default component.exports